<!--  -->
<template>
  <div class="add_box">
    <!-- <div style="margin-bottom: 10px;">
      <el-button :type="selecttype === 1? 'primary' : ''" @click="employeefrequency(1)">员工频率</el-button>
      <el-button :type="selecttype === 2? 'primary' : ''" @click="employeefrequency(2)">区间分数</el-button>
    </div> -->
    <div v-show="selecttype === 1" class="searchs_box">
      <div class="search_box">
        <el-input v-model="objr.keywords" style="width:300px;" placeholder="请输入员工编号/名称" />
        <el-select v-model="objr.onlyMe" placeholder="请选择" style="width:150px">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="sraw">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="awered">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addbit(1)">新增</el-button>
      </div>
    </div>
    <div v-show="selecttype === 2" class="search_box">
      <div>
        <el-input v-model="querytwo.keywords" style="width:300px;margin-right:10px" placeholder="请输入区间值" />
        <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="sraw">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="awered">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addbit(1)">新增</el-button>
      </div>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      v-show="selecttype === 1"
      v-loading="loadingtable"
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="corp_name"
        label="企业名称"
        width="400"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            placement="right"
            width="400"
            trigger="hover"
          >
            <div style="text-align: center; margin: 0">
              {{ scope.row.corp_name }}({{ scope.row.corp_id }})
            </div>
            <div slot="reference" class="dakwr">{{ scope.row.corp_name }}({{ scope.row.corp_id }})</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="employee_no"
        label="员工id"
        width="300"
        align="center"
      />
      <el-table-column
        prop="name"
        label="员工姓名"
        width="150"
        align="center"
      />
      <el-table-column
        prop="created_time_text"
        label="创建时间"
        width="200"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        width="100"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="消息频率"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          <div>每分钟数：{{ scope.row.min_frequency }}</div>
          <!-- <div>私聊：/图片：每天：{{ scope.row.frequency.customer.sp_image.day }},每小时：{{ scope.row.frequency.customer.sp_image.house }},每分钟：{{ scope.row.frequency.customer.sp_image.min }}</div>
          <div>私聊：/链接：每天：{{ scope.row.frequency.customer.sp_link.day }},每小时：{{ scope.row.frequency.customer.sp_link.house }},每分钟：{{ scope.row.frequency.customer.sp_link.min }}</div> -->
          <!-- <el-popover
            placement="right"
            width="400"
            trigger="hover"
          >
            <div style="text-align: center; margin: 0">
              <div style="margin-top: 10px;">私聊： 图片：每分钟：{{ scope.row.frequency.customer.sp_image.min }},每小时：{{ scope.row.frequency.customer.sp_image.house }},每天：{{ scope.row.frequency.customer.sp_image.day }}</div>
              <div style="margin-top: 10px;">私聊： 链接：每分钟：{{ scope.row.frequency.customer.sp_link.min }},每小时：{{ scope.row.frequency.customer.sp_link.house }},每天：{{ scope.row.frequency.customer.sp_link.day }}</div>
              <div style="margin-top: 10px;">私聊：小程序：每分钟：{{ scope.row.frequency.customer.sp_miniprogram.min }},每小时：{{ scope.row.frequency.customer.sp_miniprogram.house }}每天：{{ scope.row.frequency.customer.sp_miniprogram.day }}</div>
              <div style="margin-top: 10px;">私聊：文本：每分钟：{{ scope.row.frequency.customer.sp_text.min }},每小时：{{ scope.row.frequency.customer.sp_text.house }},每天：{{ scope.row.frequency.customer.sp_text.day }}</div>
              <div style="margin-top: 10px;">群聊： 图片：每分钟：{{ scope.row.frequency.group_chat.sp_image.min }},每小时：{{ scope.row.frequency.group_chat.sp_image.house }},每天：{{ scope.row.frequency.group_chat.sp_image.day }}</div>
              <div style="margin-top: 10px;">群聊： 链接：每分钟：{{ scope.row.frequency.group_chat.sp_link.min }},每小时：{{ scope.row.frequency.group_chat.sp_link.house }},每天：{{ scope.row.frequency.group_chat.sp_link.day }}</div>
              <div style="margin-top: 10px;">群聊：小程序：每分钟：{{ scope.row.frequency.group_chat.sp_miniprogram.min }},每小时：{{ scope.row.frequency.group_chat.sp_miniprogram.house }},每天：{{ scope.row.frequency.group_chat.sp_miniprogram.day }}</div>
              <div style="margin-top: 10px;">群聊：文本：每分钟：{{ scope.row.frequency.group_chat.sp_text.min }},每小时：{{ scope.row.frequency.group_chat.sp_text.house }},每天：{{ scope.row.frequency.group_chat.sp_text.day }}</div>
            </div>
            <div slot="reference" class="dakwr">私聊：图片：每分钟：{{ scope.row.frequency.customer.sp_image.min }}每小时：{{ scope.row.frequency.customer.sp_image.house }},每天：{{ scope.row.frequency.customer.sp_image.day }},...</div>
          </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column
        prop="corp_name"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="edit(2,scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleter(scope.row.employee_no)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-show="selecttype === 2"
      v-loading="loadingtable"
      :data="tableDatatwo"
      border
      style="width: 100%;margin-top:20px"
    >

      <el-table-column
        prop="employee_no"
        label="区间值(最小值-最大值)"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.integral_min }}-{{ scope.row.integral_max }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_time_text"
        label="创建时间"
        width="200"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        width="100"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="消息频率"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <div>私聊：/图片：每天：{{ scope.row.frequency.customer.sp_image.day }},每小时：{{ scope.row.frequency.customer.sp_image.house }},每分钟：{{ scope.row.frequency.customer.sp_image.min }}</div>
          <div>私聊：/链接：每天：{{ scope.row.frequency.customer.sp_link.day }},每小时：{{ scope.row.frequency.customer.sp_link.house }},每分钟：{{ scope.row.frequency.customer.sp_link.min }}</div> -->
          <!-- <el-popover
            placement="right"
            width="400"
            trigger="hover"
          >
            <div style="text-align: center; margin: 0">
              <div style="margin-top: 10px;">私聊： 图片：每分钟：{{ scope.row.frequency.customer.sp_image.min }},每小时：{{ scope.row.frequency.customer.sp_image.house }},每天：{{ scope.row.frequency.customer.sp_image.day }}</div>
              <div style="margin-top: 10px;">私聊： 链接：每分钟：{{ scope.row.frequency.customer.sp_link.min }},每小时：{{ scope.row.frequency.customer.sp_link.house }},每天：{{ scope.row.frequency.customer.sp_link.day }}</div>
              <div style="margin-top: 10px;">私聊：小程序：每分钟：{{ scope.row.frequency.customer.sp_miniprogram.min }},每小时：{{ scope.row.frequency.customer.sp_miniprogram.house }}每天：{{ scope.row.frequency.customer.sp_miniprogram.day }}</div>
              <div style="margin-top: 10px;">私聊：文本：每分钟：{{ scope.row.frequency.customer.sp_text.min }},每小时：{{ scope.row.frequency.customer.sp_text.house }},每天：{{ scope.row.frequency.customer.sp_text.day }}</div>
              <div style="margin-top: 10px;">群聊： 图片：每分钟：{{ scope.row.frequency.group_chat.sp_image.min }},每小时：{{ scope.row.frequency.group_chat.sp_image.house }},每天：{{ scope.row.frequency.group_chat.sp_image.day }}</div>
              <div style="margin-top: 10px;">群聊： 链接：每分钟：{{ scope.row.frequency.group_chat.sp_link.min }},每小时：{{ scope.row.frequency.group_chat.sp_link.house }},每天：{{ scope.row.frequency.group_chat.sp_link.day }}</div>
              <div style="margin-top: 10px;">群聊：小程序：每分钟：{{ scope.row.frequency.group_chat.sp_miniprogram.min }},每小时：{{ scope.row.frequency.group_chat.sp_miniprogram.house }},每天：{{ scope.row.frequency.group_chat.sp_miniprogram.day }}</div>
              <div style="margin-top: 10px;">群聊：文本：每分钟：{{ scope.row.frequency.group_chat.sp_text.min }},每小时：{{ scope.row.frequency.group_chat.sp_text.house }},每天：{{ scope.row.frequency.group_chat.sp_text.day }}</div>
            </div>
            <div slot="reference" class="dakwr">私聊：图片：每分钟：{{ scope.row.frequency.customer.sp_image.min }}每小时：{{ scope.row.frequency.customer.sp_image.house }},每天：{{ scope.row.frequency.customer.sp_image.day }},...</div>
          </el-popover> -->
          <div>每分钟数：{{ scope.row.min_frequency }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="corp_name"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="edit(2,scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleter(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="新增设置"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="updatar"
    >
      <fredialog ref="fredialogview" @updata="updata" />
    </el-dialog>

    <pagination-right
      v-show="selecttype === 1"
      ref="paginationbox"
      :current-page="objr.page"
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
    <pagination-right
      v-show="selecttype === 2"
      ref="paginationbox"
      :current-page="querytwo.page"
      :total="newtotalrtwo"
      @size-change="fetchPageSizertwo($event)"
      @current-change="fetchCurrentPagertwo"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { frequencyindex, frequencydelete, integralFrequencyindex, integralFrequencydelete } from '@/api/officialaccount.js'
import fredialog from './components/fredialog.vue'
export default {
  components: {
    PaginationRight,
    fredialog
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        page_size: 10,
        keywords: null,
        onlyMe: 2
      },
      newtotalr: null,
      tableData: [],
      loadingtable: false,
      accountarr: [{
        value: 1,
        label: '查看组内员工'
      }, {
        value: 2,
        label: '我关联的员工'
      }],
      type: null,
      selecttype: 1,
      querytwo: {
        page: 1,
        page_size: 10,
        keywords: null
      },
      tableDatatwo: [],
      newtotalrtwo: null
    }
  },
  created() {
    this.menuList()
  },
  mounted() {

  },
  methods: {
    employeefrequency(type) {
      this.selecttype = type
      if (this.selecttype === 1) {
        this.menuList()
      } else {
        this.twomenuList()
      }
    },
    async menuList() {
      // 获取列表
      // this.loadingtable = true
      const data = await frequencyindex(this.objr)
      console.log('data', data)
      // this.loadingtable = false
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    async twomenuList() {
      const data = await integralFrequencyindex(this.querytwo)
      this.tableDatatwo = data.data.list
      this.newtotalrtwo = data.data.total
    },
    updatar() {
      if (this.type === 2 && this.selecttype === 1) {
        this.menuList()
      }
      if (this.type === 2 && this.selecttype === 2) {
        this.twomenuList()
      }
    },
    sraw() {
      if (this.selecttype === 1) {
        this.objr.page = 1
        this.objr.page_size = 10
        this.menuList()
      } else {
        this.querytwo.page = 1
        this.querytwo.page_size = 10
        this.twomenuList()
      }
    },
    awered() {
      if (this.selecttype === 1) {
        this.objr.page = 1
        this.objr.page_size = 10
        this.objr.keywords = null
        this.objr.onlyMe = 2
        this.menuList()
      } else {
        this.querytwo.page = 1
        this.querytwo.page_size = 10
        this.querytwo.keywords = null
        this.twomenuList()
      }
    },
    addbit(type) {
      this.dialogVisible = true
      this.type = type
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.fredialogview.send(type, {}, this.selecttype)
      }, 100)
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.page_size = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    // 分页
    fetchPageSizertwo(e) {
      this.querytwo.page_size = e
      this.twomenuList()
    },
    fetchCurrentPagertwo(e) {
      this.querytwo.page = e
      this.twomenuList()
    },
    updata() {
      this.dialogVisible = false
      this.menuList()
    },
    edit(type, item) {
      this.type = type
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.fredialogview.send(type, item, this.selecttype)
      }, 100)
    },
    deleter(employee_no) {
      console.log('666')
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        if (this.selecttype === 1) {
          frequencydelete({
            employee_no: employee_no
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.menuList()
          })
        } else {
          integralFrequencydelete({
            id: employee_no
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.twomenuList()
          })
        }
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box{
  padding: 20px;
}
.searchs_box{
  display: flex;
  align-items: center;
  flex-wrap:wrap;
  justify-content: space-between;
}
.dakwr{
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
@media (max-width: 768px){
  .searchs_box{
    justify-content: flex-end;
  }
}

</style>
